import CHILE_OFFER_FLOW_STEP_IDS from '../../../../../constants/factoring/chile-offer-flow-step-ids';
import CredentialProviderCredentialsStep from '../../steps/CredentialProviderCredentialsStep';

export default function buildCredentialProviderCredentialsConfiguration({
  selectedProvider,
}) {
  return {
    id: CHILE_OFFER_FLOW_STEP_IDS.CREDENTIAL_PROVIDER_CREDENTIALS,
    title: 'Ingresa las credenciales de tu facturador',
    tooltipTitle:
      'Si olvidaste los datos de tu cuenta, acude a tu facturador para recuperarlos',
    component: CredentialProviderCredentialsStep,
    props: { selectedProvider },
  };
}
